import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import "./contactUs.css"
import RingLoader from "react-spinners/RingLoader";
import ButtonMailto from '../fullpage/page5/buttonEmail';
ContactUs.propTypes = {

};

function ContactUs(props) {


    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 3000);
    }, [])

    return (
        <div className="contact-us-cover">
            {
                isLoading ?
                    <div className="loading" >
                        <RingLoader color={'#34CEE6'} loading={isLoading} size={150} />
                    </div>
                    :
                    <div className="container">
                        <div className="title">
                            <p className={isLoading ? "title-inactive":"title-active"}>Contact Us</p>
                        </div>
                        <div className="cover-content">
                            <div className="cover-map">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.8219215313925!2d106.71850181462219!3d10.748203992340672!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752f7e59b66ddf%3A0x38ab8ec1e384cb3a!2zSOG6u20gMTQzIFTDom4gTeG7uSwgVMOibiBUaHXhuq1uIFTDonksIFF14bqtbiA3LCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmgsIFZp4buHdCBOYW0!5e0!3m2!1svi!2s!4v1626815312021!5m2!1svi!2s" width="100%" height="100%"
                                    allowfullscreen="true" loading="lazy"></iframe>
                            </div>
                            <div className="cover-detail">
                                <div className="address">
                                    <p>143/14/23 Tân Mỹ, Tân Thuận Tây, Quận 7, TPHCM</p>
                                </div>
                                <div className="email-contact">
                                    <p>Work With Us.</p>
                                    <ButtonMailto label="kendidang2k@gmail.com" mailto="mailto:kendidang2k@gmail.com"></ButtonMailto>
                                    <p>Careers.</p>
                                    <ButtonMailto label="kendidang2k@gmail.com" mailto="mailto:kendidang2k@gmail.com"></ButtonMailto>
                                </div>
                            </div>
                        </div>
                    </div>
            }

        </div>
    );
}

export default ContactUs;